// As parametr accepts selector of parent block,
// selector hidden part (default = '.js-show-more-hidden'),
// selector for button (default '.js-show-more-button')
export default function showMore(
	$parentElem,
	hiddenContentSelector = "[data-show-more-hidden]",
	showMoreButtonSelector = "[data-show-more-button]"
) {
	const $hiddenContent = $parentElem.find( hiddenContentSelector ).first();
	const $showMoreButton = $parentElem.find( showMoreButtonSelector ).first();
	const $showMoreButtonText = $showMoreButton.find( "[data-show-more-button-text" );
	const defaultText = $showMoreButtonText.text();

	if ( !$parentElem.length || !$showMoreButton.length || !$hiddenContent.length ) {
		return;
	}

	const initializeMediaQueryListener = ( query, $hiddenContent, $showMoreButton ) => {
		const mediaQuery = window.matchMedia( query );

		mediaQuery.addEventListener( "change", ( event ) => {
			setDefaultShowMoreState( event.matches, $hiddenContent, $showMoreButton );
		} );

		setDefaultShowMoreState( mediaQuery.matches, $hiddenContent, $showMoreButton );
	};

	const setupResponsiveBehavior = ( $hiddenContent ) => {
		if ( $hiddenContent.hasClass( "mobile" ) ) {
			initializeMediaQueryListener( "(min-width: 768px)", $hiddenContent, $showMoreButton );
		} else if ( $hiddenContent.hasClass( "desktop" ) && $parentElem.closest( hiddenContentSelector ) ) {
			initializeMediaQueryListener( "(max-width: 767px)", $hiddenContent, $showMoreButton );
		}
	};

	const toggleContentVisibility = () => {
		const speed = $hiddenContent.hasClass( "mobile" ) ? 800 : 300;
		const isOpen = $showMoreButton.hasClass( "opened" );

		$hiddenContent[isOpen ? "slideUp" : "slideDown"]( speed, () => {
			$showMoreButtonText.text( isOpen ? defaultText : "Hide" );
		} );

		$showMoreButton.toggleClass( "opened", !isOpen );
	};

	setupResponsiveBehavior( $hiddenContent );

	$showMoreButton.off( "click" ).on( "click", toggleContentVisibility );
}


function setDefaultShowMoreState( matches, $hiddenContent, $showMoreButton ) {
	const $showMoreButtonText = $showMoreButton.find( "[data-show-more-button-text]" );
	const defaultText = $showMoreButtonText.text();
	if ( matches ) {
		$hiddenContent.show();
		$showMoreButtonText.text( "Hide" );
		$showMoreButton.addClass( "opened" );
	} else {
		$hiddenContent.hide();
		$showMoreButtonText.text( defaultText );
		$showMoreButton.removeClass( "opened" );
	}
}
